<template>
  <div style="padding-top: 1rem">
    <!--<navTitle title="充值/提现"></navTitle>-->
    <navTitle
      :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'Deposit & withdrawals'
      "
    ></navTitle>

    <div class="recharge">
      <div class="nav acea-row row-around row-middle">
        <div
          class="item"
          :class="active === index ? 'on' : ''"
          v-for="(item, index) in navRecharge"
          :key="index"
          @click="navRecharges(index)"
        >
          {{ item }}
        </div>
      </div>
      <div class="info-wrapper">
        <div class="money">
          <span>₫</span>
          <input type="number" placeholder="0.00" v-model="money" />
        </div>
        <div class="tips" v-if="!active">
          Note : Maximum <span>₫{{ list.money || 0 }}</span> transfer out
        </div>
        <div class="tips" v-else>
          Note : Maximum <span>₫{{ userInfo.now_money || 0 }}</span> transfer in
        </div>
        <div class="pay-btn bg-color-blue" @click="recharge">
          {{ active ? "Transfer in" : "Transfer out" }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
import {
  rechargeWechat,
  deposit_info,
  deposit_add,
  deposit_out,
  getUserInfo
} from "@api/user";
import { add, sub } from "@utils/bc";
import navTitle from "@components/navTitle";

export default {
  name: "Recharge",
  components: { navTitle },
  props: {},
  data: function() {
    return {
      navRecharge: ["Transfer out", "Transfer in"],
      // navRecharge: ["账户充值"],
      active: 0,
      payType: ["weixin"],
      from: isWeixin() ? "weixin" : "weixinh5",
      money: "",
      now_money: "",
      list: [],
      userInfo: ""
    };
  },
  inject: ["app"],

  watch: {
    $route(n) {
      // console.log('type',n)

      if (n.name === "bankRecharge") {
        // console.log('type',n)
        this.active = parseInt(this.$route.params.type) || 0;
      }
    }
  },
  // computed: mapGetters(["userInfo"]),
  mounted: function() {
    this.active = parseInt(this.$route.query.type) || 0;
    this.now_money = this.userInfo.now_money;
    this.getInfo();
    this.getUserInfo();
  },
  methods: {
    getInfo() {
      deposit_info().then(res => {
        this.list = res.data;
      });
    },
    getUserInfo() {
      getUserInfo().then(res => {
        this.userInfo = res.data;
      });
    },
    navRecharges: function(index) {
      this.active = index;
    },
    recharge: function() {
      let that = this,
        price = Number(this.money);
      if (this.active == 0) {
        //转出
        if (price === 0) {
          return that.$dialog.toast({ mes: "Please enter the amount to transfer out" });
        }
        this.$dialog.loading.open("Processing...");
        deposit_out({ money: this.money })
          .then(res => {
            this.$dialog.loading.close();
            this.getInfo();
            this.getUserInfo();
            this.$dialog.confirm({
              mes: "Successfully transferred out",
              title: "Message",
              opts: [
                {
                  txt: "Confirm",
                  color: false,
                  callback: () => {
                    that.$router.go(-1)
                  }
                }
              ]
            });

          })
          .catch(res => {
            this.$dialog.loading.close();
            this.$dialog.error(res.msg);
          });
      } else {
        //转入
        if (price === 0) {
          return that.$dialog.toast({ mes: "Please enter amount to top up" });
        }
        this.$dialog.loading.open("Processing...");
        deposit_add({ money: this.money })
          .then(res => {
            // console.log('转入',res)
            this.$dialog.loading.close();
            this.getUserInfo();
            this.getInfo();
            this.$dialog.confirm({
              mes: "Successfully transferred in",
              title: "Message",
              opts: [
                {
                  txt: "Confirm",
                  color: false,
                  callback: () => {
                    that.$router.go(-1)
                  }
                }
              ]
            });

          })
          .catch(res => {
            this.$dialog.loading.close();
            this.$dialog.error(res.msg);
          });
      }
    }
  }
};
</script>
<style scoped>
#iframe {
  display: none;
}
.recharge {
  width: 7.03rem;
  padding: 0.5rem 0.63rem 0.45rem;
  background-color: #fff;
  margin: 0.2rem auto 0 auto;
  border-radius: 0.1rem;
}
.recharge .nav {
  height: 0.75rem;
  line-height: 0.75rem;
  padding: 0 1rem;
}
.recharge .nav .item {
  font-size: 0.3rem;
  color: #333;
}
.recharge .nav .item.on {
  font-weight: bold;
  border-bottom: 0.04rem solid #00c3f9;
}
.recharge .info-wrapper {
  text-align: center;
}
.recharge .info-wrapper .money {
  margin-top: 0.6rem;
  padding-bottom: 0.2rem;
  border-bottom: 1px dashed #ddd;
}
.recharge .info-wrapper .money span {
  font-size: 0.56rem;
  color: #333;
  font-weight: bold;
}
.recharge .info-wrapper .money input {
  display: inline-block;
  width: 3rem;
  font-size: 0.84rem;
  text-align: center;
  color: #282828;
  font-weight: bold;
  padding-right: 0.7rem;
}
.recharge .info-wrapper .money input::placeholder {
  color: #ddd;
}
.recharge .info-wrapper .money input::-webkit-input-placeholder {
  color: #ddd;
}
.recharge .info-wrapper .money input:-moz-placeholder {
  color: #ddd;
}
.recharge .info-wrapper .money input::-moz-placeholder {
  color: #ddd;
}
.recharge .info-wrapper .money input:-ms-input-placeholder {
  color: #ddd;
}
.recharge .info-wrapper .tips {
  font-size: 0.26rem;
  color: #888;
  margin: 0.25rem auto 0 auto;
  line-height: 1.5;
  padding: 0 0.3rem;
}
.recharge .info-wrapper .tips span {
  color: #ef4a49;
}
.recharge .info-wrapper .pay-btn {
  display: block;
  width: 5.5rem;
  height: 0.86rem;
  margin: 0.5rem auto 0 auto;
  line-height: 0.86rem;
  text-align: center;
  color: #fff;
  border-radius: 0.15rem;
  font-size: 0.3rem;
  font-weight: bold;
}
</style>
